//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('counter', {
//        templateUrl: 'views/components/views/counter/counter.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'counterService', function ($stateParams, stateService, translateService, modalService, counterService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let counterKeyno = $stateParams.counter_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                lastNumberButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.lastnumber = 0 },
//                    { id: 'calculator', icon: 'fa fa-calculator', color: 'primary', type: 'primary', onClick: () => openCalculator('lastnumber') },
//                    { id: 'previous', icon: 'fa fa-minus', color: 'primary', type: 'primary', onClick: () => vm.model.edit.lastnumber-- },
//                    { id: 'next', icon: 'fa fa-plus', color: 'primary', type: 'primary', onClick: () => vm.model.edit.lastnumber++ }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await counterService.getCounter({ counter_keyno: counterKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            function openCalculator(id) {
//                switch (id) {
//                    case 'lastnumber':
//                        modalService.showCalculator(vm.model.edit[id]).then(function (value) {
//                            vm.model.edit[id] = value;
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion OPEN CALCULATOR DIALOGUE BOX FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                counterService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                    loadEdit();
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
